export const sessionKeys = {
    all: ["sessions"] as const,
    sessions: () => [...sessionKeys.all] as const,
    session: (id: string) => [...sessionKeys.all, id] as const,
} as const;

export const chatKeys = {
  base: ["chat"] as const,
  chatHistory: (sessionId: string) => [...chatKeys.base, "history", sessionId] as const,
};
